'use client';

import { createContext, useContext, useEffect, useState, ReactNode } from 'react';

interface MaintenanceContextType {
  maintenance: boolean;
  message: string;
}

const MaintenanceContext = createContext<MaintenanceContextType>({ maintenance: false, message: '' });

const POLL_MS = 60_000; // re-check every minute so the banner appears/clears without a reload

export function MaintenanceProvider({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<MaintenanceContextType>({ maintenance: false, message: '' });

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const res = await fetch('/api/maintenance-status');
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled) setStatus({ maintenance: !!data.maintenance, message: data.message || '' });
      } catch {
        /* fail open — no banner rather than a broken app */
      }
    };
    check();
    const id = setInterval(check, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return <MaintenanceContext.Provider value={status}>{children}</MaintenanceContext.Provider>;
}

export function useMaintenance(): MaintenanceContextType {
  return useContext(MaintenanceContext);
}
